export default "__VITE_ASSET__DV8GPf2r__"